export interface FormLocationInfo {
    gfv: string;
    formPath: string;
}
